/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a metadata of an Order Subsequent Document
 * @export
 * @interface SAPOrderSubsequentDocument
 */
export interface SAPOrderSubsequentDocument {
    /**
     * Document Id
     * @type {string}
     * @memberof SAPOrderSubsequentDocument
     */
    sapDocumentId?: string;
    /**
     * UI Name for the column with ID's of the Document Entries
     * @type {string}
     * @memberof SAPOrderSubsequentDocument
     */
    sapDocumentEntryIdColumnName?: string;
    /**
     * 
     * @type {Array<SAPOrderSubsequentDocument>}
     * @memberof SAPOrderSubsequentDocument
     */
    sapSubsequentDocuments?: Array<SAPOrderSubsequentDocument>;
    /**
     * Creation Date/Time
     * @type {string}
     * @memberof SAPOrderSubsequentDocument
     */
    sapCreatedAt?: string;
    /**
     * Name of the status of the document
     * @type {string}
     * @memberof SAPOrderSubsequentDocument
     */
    sapStatus?: string;
    /**
     * UI Name for the column with ID's of the Document Entries
     * @type {string}
     * @memberof SAPOrderSubsequentDocument
     */
    sapDocumentCategory?: string;
}

/**
 * Check if a given object implements the SAPOrderSubsequentDocument interface.
 */
export function instanceOfSAPOrderSubsequentDocument(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SAPOrderSubsequentDocumentFromJSON(json: any): SAPOrderSubsequentDocument {
    return SAPOrderSubsequentDocumentFromJSONTyped(json, false);
}

export function SAPOrderSubsequentDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAPOrderSubsequentDocument {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sapDocumentId': !exists(json, 'sapDocumentId') ? undefined : json['sapDocumentId'],
        'sapDocumentEntryIdColumnName': !exists(json, 'sapDocumentEntryIdColumnName') ? undefined : json['sapDocumentEntryIdColumnName'],
        'sapSubsequentDocuments': !exists(json, 'sapSubsequentDocuments') ? undefined : ((json['sapSubsequentDocuments'] as Array<any>).map(SAPOrderSubsequentDocumentFromJSON)),
        'sapCreatedAt': !exists(json, 'sapCreatedAt') ? undefined : json['sapCreatedAt'],
        'sapStatus': !exists(json, 'sapStatus') ? undefined : json['sapStatus'],
        'sapDocumentCategory': !exists(json, 'sapDocumentCategory') ? undefined : json['sapDocumentCategory'],
    };
}

export function SAPOrderSubsequentDocumentToJSON(value?: SAPOrderSubsequentDocument | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sapDocumentId': value.sapDocumentId,
        'sapDocumentEntryIdColumnName': value.sapDocumentEntryIdColumnName,
        'sapSubsequentDocuments': value.sapSubsequentDocuments === undefined ? undefined : ((value.sapSubsequentDocuments as Array<any>).map(SAPOrderSubsequentDocumentToJSON)),
        'sapCreatedAt': value.sapCreatedAt,
        'sapStatus': value.sapStatus,
        'sapDocumentCategory': value.sapDocumentCategory,
    };
}

